import type { ReactNode } from 'react';
import { MdArrowDropDown, MdClose } from 'react-icons/md';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export type MailRecipientsDropdownItem = {
  key: string | number;
  label: ReactNode;
  description?: ReactNode;
  onRemove?: () => void;
};

type MailRecipientsDropdownProps = {
  items: MailRecipientsDropdownItem[];
  disabled?: boolean;
};

export default function MailRecipientsDropdown({ items, disabled }: MailRecipientsDropdownProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="送信先を全て表示"
          disabled={disabled || items.length === 0}
          className="flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-sm border-none bg-transparent p-0 text-main transition-colors hover:bg-gray disabled:cursor-not-allowed disabled:opacity-50 data-[state=open]:bg-gray_darken"
        >
          <MdArrowDropDown className="size-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="max-h-[320px] w-[320px] overflow-y-auto rounded-sm px-md py-sm shadow-layer3!"
      >
        <ul className="flex flex-col">
          {items.map((item) => (
            <li key={item.key} className="group flex items-start gap-xs py-[2px]">
              <div className="min-w-0 flex-1 text-body-sm break-words text-main">
                {item.label}
                {item.description && <div className="text-body-xs">{item.description}</div>}
              </div>
              {item.onRemove && (
                <button
                  type="button"
                  aria-label="送信先から外す"
                  onClick={item.onRemove}
                  className="flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-sm border-none bg-transparent p-0 text-sub opacity-0 transition group-hover:opacity-100 hover:bg-gray hover:text-main focus-visible:opacity-100"
                >
                  <MdClose className="size-4" />
                </button>
              )}
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
